export default "__VITE_ASSET__Ccy9gVg3__"